import { render, staticRenderFns } from "./AdditionalSourcesComponent.vue?vue&type=template&id=d2e56ac2"
import script from "./AdditionalSourcesComponent.vue?vue&type=script&lang=js"
export * from "./AdditionalSourcesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports